<div *ngIf="isCourseView" class="programme-card">
  <!-- Left Side: Cover Image -->
  <div class="programme-img-container">
    <img *ngIf="item?.image" [src]="item?.image" style="width: 100%; height: 100%; object-fit: cover;"
      alt="Cover image" />

    <!-- Match Badge -->
    <!-- <div style="position: absolute; bottom: 16px; left: 16px; background: #FFC107; border-radius: 24px; padding: 6px 14px; display: flex; align-items: center; gap: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
      <i class="pi pi-sparkles" style="color: #000086; font-size: 14px;"></i>
      <span style="color: #000086; font-weight: 700; font-size: 14px;">{{ item?.matchPercentage }}% Match</span>
    </div> -->
  </div>

  <!-- Right Side: Content -->
  <div style="flex: 1; padding: 24px; display: flex; flex-direction: column;">

    <!-- Header Row -->
    <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 8px;">
      <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 12px;">
        <h3 style="font-size: 20px; font-weight: 700; color: #0f172a; margin: 0;">
          {{ programmeHeading || item?.courseName || item?.instituteName }}
        </h3>

        <div *ngIf="item?.qsRanking"
          style="border: 1px solid #cbd5e1; border-radius: 20px; padding: 4px 12px; color: #000086; font-weight: 700; font-size: 13px;">
          #{{ item?.qsRanking }} QS World University Ranking
        </div>
        <div *ngIf="item?.nirfRanking"
          style="border: 1px solid #cbd5e1; border-radius: 20px; padding: 4px 12px; color: #000086; font-weight: 700; font-size: 13px;">
          #{{ item?.nirfRanking }} NIRF Ranking
        </div>

        <div *ngIf="item?.isPartner" style="display: flex; gap: 8px;">
          <div
            style="background: #E0E0FF; border-radius: 20px; padding: 4px 12px; color: #000086; font-weight: 700; font-size: 13px; text-transform: uppercase; display: flex; align-items: center; gap: 4px;">
            <span>Partner</span>
          </div>
          <div
            style="background: #E0E0FF; border-radius: 20px; padding: 4px 12px; color: #000086; font-weight: 700; font-size: 13px; display: flex; align-items: center;">
            <span *ngIf="hasFees(item)">Fees: {{ item?.agentFeeCurrency }} {{ item?.agentApplicationFees }}</span>
            <span *ngIf="!hasFees(item)">Fees: Fees Waiver</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Sub-info Row -->
    <div style="font-size: 14px; color: #64748b; margin-bottom: 24px;">
      {{ item?.courseLevel || 'M.S.' }} &middot;
      {{ item?.courseFormat || 'Full-time' }} &middot;
      {{ item?.deliveryMode || 'On campus' }} &middot;
      {{ item?.duration || '1 year' }}
    </div>

    <!-- University & Reviews -->
    <div style="display: flex; flex-direction: column; gap: 12px; margin-bottom: 24px;">
      <div style="display: flex; align-items: center; gap: 12px;">
        <div
          style="width: 32px; height: 32px; border-radius: 6px; background: #f8fafc; border: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: center; overflow: hidden;">
          <img *ngIf="item?.logo" [src]="item?.logo" style="width: 100%; height: 100%; object-fit: contain;" />
          <i *ngIf="!item?.logo" class="pi pi-building" style="color: #94a3b8; font-size: 16px;"></i>
        </div>
        <span style="font-size: 15px; font-weight: 600; color: #0f172a;">{{ item?.instituteName }}</span>
      </div>

      <!-- <div style="display: flex; align-items: center; gap: 12px;">
        <div style="background: #000086; color: #fff; font-weight: 700; font-size: 13px; padding: 4px 8px; border-radius: 6px;">
          {{ item?.reviewScore }}
        </div>
        <span style="font-size: 14px; color: #64748b;">{{ item?.reviewCount | number }} reviews</span>
      </div> -->
    </div>

    <!-- Actions Row -->
    <div
      style="display: flex; align-items: center; justify-content: space-between; border-top: 1px solid #f1f5f9; padding-top: 20px; margin-top: auto;">
      <a [routerLink]="[portal === 'mentor' ? '/mentor-portal' : '/portal', item?.id, 'institute']"
        style="font-size: 14px; font-weight: 600; color: #000086; text-decoration: underline; cursor: pointer;">
        View programme information
      </a>

      <button *ngIf="item?.isPartner && !hasAssignedMentor && portal !== 'mentor'" (click)="onDirectApplyClick($event)"
        [disabled]="isDirectApplied"
        [title]="isDirectApplied ? 'This institute is already added to Direct Apply' : ''"
        [ngStyle]="{'background': isDirectApplied ? '#cbd5e1' : '#000086', 'cursor': isDirectApplied ? 'not-allowed' : 'pointer'}"
        style="color: #fff; border: none; border-radius: 8px; padding: 10px 24px; font-size: 14px; font-weight: 600; transition: opacity 0.2s; display: inline-block;"
        onmouseover="if(!this.disabled) this.style.opacity='0.9'" onmouseout="if(!this.disabled) this.style.opacity='1'">
        Shortlist & Apply
      </button>

      <button *ngIf="!item?.isPartner || hasAssignedMentor || portal === 'mentor'" (click)="isInstituteSaved ? myInstituteEmitter.emit({ instituteId: item?.id ?? '', courseId: undefined }) : onSaveClick()"
        style="color: #fff; border: none; border-radius: 8px; padding: 10px 24px; font-size: 14px; font-weight: 600; transition: opacity 0.2s; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; min-width: 140px;"
        [ngStyle]="{'background': isInstituteSaved ? '#e11d48' : '#000086'}"
        onmouseover="this.style.opacity='0.9'" onmouseout="this.style.opacity='1'">
        <i class="pi" [ngClass]="isInstituteSaved ? 'pi-heart-fill' : 'pi-heart'" style="margin-right: 8px; font-size: 14px;"></i>
        {{ isInstituteSaved ? 'Saved' : 'Save Programme' }}
      </button>
    </div>

  </div>
</div>

<div *ngIf="!isCourseView"
  style="position: relative; background: white; border-radius: 12px; overflow: hidden; display: flex; flex-direction: column; height: 100%; box-shadow: 0 4px 12px rgba(0,0,0,0.08); border: 1px solid #e2e8f0;">

  <div style="height: 180px; position: relative; background: #BDBDBD; overflow: hidden; flex-shrink:0;">
    <img *ngIf="item?.image" style="width: 100%; height: 100%; object-fit: cover;" [src]="item?.image" />
    <div *ngIf="!item?.image"
      style="width: 100%; height: 100%; background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);"></div>

    <div *ngIf="isValidDate(item?.applicationDeadlineRegularDecision)"
      style="position: absolute; right: 16px; top: 16px; background: #CDD12A; border-radius: 32px; padding: 6px 16px; display: inline-flex; justify-content: center; align-items: center;">
      <div style="color: #000; font-size: 13px; font-weight: 600;">
        Upcoming Deadline: {{ item?.applicationDeadlineRegularDecision | date:'MMM d, yyyy' }}
      </div>
    </div>
  </div>

  <div style="padding: 0 24px 24px 24px; position: relative; flex: 1; display: flex; flex-direction: column;">

    <div
      style="width: 100px; height: 100px; margin-top: -50px; background: #fff; overflow: hidden; display: flex; align-items: center; justify-content: center; margin-bottom: 20px; border: 4px solid #fff; z-index: 2;">
      <img *ngIf="item?.logo" style="width: 100%; height: 100%; object-fit: contain; background: #fafafa;"
        [src]="item?.logo" />
      <div *ngIf="!item?.logo"
        style="width: 100%; height: 100%; background: #fafafa; display: flex; align-items: center; justify-content: center;">
        <i class="pi pi-building" style="color:#94a3b8; font-size:32px;"></i>
      </div>
    </div>

    <!-- <i class="pi cursor-pointer" [ngClass]="isInstituteSaved ? 'pi-heart-fill' : 'pi-heart'"
      [style.color]="isInstituteSaved ? '#e11d48' : '#cbd5e1'"
      style="position: absolute; right: 24px; top: 24px; font-size: 22px; transition: color 0.15s;"
      [title]="isInstituteSaved ? 'Saved' : 'Save to My Colleges'" (click)="isInstituteSaved
        ? myInstituteEmitter.emit({ instituteId: item?.id ?? '', courseId: undefined })
        : onSaveClick()">
    </i> -->

    <div style="display: flex; align-items: flex-start; gap: 12px; margin-bottom: 4px; flex-wrap: wrap;">
      <a [routerLink]="[portal === 'mentor' ? '/mentor-portal' : '/portal', item?.id, 'institute']"
        style="color: #0f172a; font-size: clamp(20px, 4vw, 24px); font-weight: 800; word-wrap: break-word; line-height: 1.2; text-decoration: none; cursor: pointer;">
        {{ item?.instituteName }}
      </a>
      <div *ngIf="item?.isPartner" style="display: flex; gap: 8px; margin-top: 4px; flex-wrap: wrap;">
        <div
          style="border: 1px solid #cbd5e1; border-radius: 20px; padding: 4px 12px; color: #0f172a; font-weight: 600; font-size: 13px; display: flex; align-items: center; gap: 4px;">
          <span>Partner</span>
        </div>
        <div
          style="border: 1px solid #cbd5e1; border-radius: 20px; padding: 4px 12px; color: #0f172a; font-weight: 600; font-size: 13px; display: flex; align-items: center;">
          <span *ngIf="hasFees(item)">Fees: {{ item?.agentFeeCurrency }} {{ item?.agentApplicationFees }}</span>
          <span *ngIf="!hasFees(item)">Fees: Fees Waiver</span>
        </div>
      </div>
    </div>
    <div style="color: #64748b; font-size: 15px; font-weight: 500; word-wrap: break-word; margin-bottom: 24px;">
      {{ item?.city }}, {{ item?.country }}
    </div>

    <div style="display: flex; flex-direction: column; gap: 14px; margin-bottom: 32px; margin-top: auto;">
      <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
        <div *ngIf="item?.qsRanking" style="color: #0f172a; font-size: 15px; font-weight: 600;">QS Ranking: {{ item?.qsRanking }}</div>
        <div *ngIf="item?.nirfRanking" style="color: #0f172a; font-size: 15px; font-weight: 600;">NIRF Ranking: {{ item?.nirfRanking }}</div>
      </div>
      <div style="display: flex; align-items: center; gap: 12px;">
        <i class="pi pi-wallet" style="color:#000086; font-size: 18px;"></i>
        <div style="color: #0f172a; font-size: 15px; font-weight: 600;">
          Fees per year: {{ getAmount(item?.currency, item?.averageTutionFees ?? 0) }}
          <!-- Fees per year: {{ getAmount(item!.currency,
          item?.averageTutionFees ?? 0) }} -->
          </div>
      </div>
      <div style="display: flex; align-items: center; gap: 12px;">
        <i class="pi pi-graduation-cap" style="color:#000086; font-size: 18px;"></i>
        <div style="color: #0f172a; font-size: 15px; font-weight: 600;">Course Duration: {{ item?.duration || '48
          months' }}</div>
      </div>
    </div>

    <div style="display: flex; gap: 12px; flex-wrap: wrap;">
      <a [routerLink]="[portal === 'mentor' ? '/mentor-portal' : '/portal', item?.id, 'institute']"
        style="flex: 1 1 120px; height: 48px; background: #000086; border-radius: 6px; display: flex; justify-content: center; align-items: center; color: white; font-size: 15px; font-weight: 700; text-decoration: none; cursor: pointer; transition: opacity 0.2s;"
        onmouseover="this.style.opacity='0.9'" onmouseout="this.style.opacity='1'">
        View University
      </a>

      <button *ngIf="item?.isPartner && !hasAssignedMentor && portal !== 'mentor'" (click)="onDirectApplyClick($event)"
        [disabled]="isDirectApplied"
        [title]="isDirectApplied ? 'This institute is already added to Direct Apply' : ''"
        [ngStyle]="{'background': isDirectApplied ? '#cbd5e1' : '#000086', 'cursor': isDirectApplied ? 'not-allowed' : 'pointer'}"
        style="flex: 1 1 120px; height: 48px; border-radius: 6px; display: flex; justify-content: center; align-items: center; color: white; font-size: 15px; font-weight: 700; border: none; transition: opacity 0.2s;"
        onmouseover="if(!this.disabled) this.style.opacity='0.9'" onmouseout="if(!this.disabled) this.style.opacity='1'">
        Direct Apply
      </button>

      <button *ngIf="!item?.isPartner || hasAssignedMentor || portal === 'mentor'" (click)="isInstituteSaved ? myInstituteEmitter.emit({ instituteId: item?.id ?? '', courseId: undefined }) : onSaveClick()"
        style="flex: 1 1 120px; height: 48px; border-radius: 6px; display: flex; justify-content: center; align-items: center; font-size: 15px; font-weight: 700; border: 1px solid #000086; transition: opacity 0.2s; cursor: pointer;"
        [ngStyle]="{'background': isInstituteSaved ? '#e11d48' : '#fff', 'color': isInstituteSaved ? '#fff' : '#000086', 'border-color': isInstituteSaved ? '#e11d48' : '#000086'}"
        onmouseover="this.style.opacity='0.8'" onmouseout="this.style.opacity='1'">
        <i class="pi" [ngClass]="isInstituteSaved ? 'pi-heart-fill' : 'pi-heart'" style="margin-right: 6px;"></i>
        {{ isInstituteSaved ? 'Saved' : 'Save' }}
      </button>
    </div>
  </div>
</div>

<p-dialog [(visible)]="showCourseDialog" [modal]="true" [style]="{ width: '40rem' }"
  [breakpoints]="{ '575px': '90vw' }" (onHide)="cancelDialog()" [showHeader]="false" [dismissableMask]="true"
  [contentStyle]="{ 'padding': '0', 'border-radius': '32px', 'overflow': 'hidden' }">

  <!-- Header Section -->
  <div style="background-color: #CDD12A; padding: 24px 24px 20px; text-align: center; position: relative;">
    <div style="position: absolute; right: 16px; top: 16px; width: 36px; height: 36px; border-radius: 50%; display: flex; justify-content: center; align-items: center; cursor: pointer; transition: background-color 0.2s;"
      onmouseover="this.style.backgroundColor='rgba(0, 0, 134, 0.1)'"
         onmouseout="this.style.backgroundColor='transparent'"
         (click)="cancelDialog()">
      <i class="pi pi-times" style="font-size: 1.25rem; color: #000086; font-weight: bold;"></i>
    </div>
    <div style="font-size: 14px; font-weight: 500; color: #000; margin-bottom: 4px;">
      Course Selection
    </div>
    <div style="font-size: 24px; font-weight: 600; color: #000086; line-height: 1.3;">
      {{item?.instituteName}}
    </div>
  </div>

  <!-- Content Section -->
  <div style="padding: 32px 24px 32px; background-color: #ffffff;">
    <div *ngIf="loadingCourses" class="flex justify-content-center py-3">
      <i class="pi pi-spin pi-spinner" style="font-size:2rem"></i>
    </div>

    <div *ngIf="!loadingCourses" class="flex flex-column gap-4">

      <div>
        <label class="font-bold text-sm mb-2 block" style="color: #0f172a;">Course level</label>
        <p-dropdown [options]="courseLevelOptions" [(ngModel)]="selectedCourseLevel" optionLabel="label"
          optionValue="value" placeholder="Select Course Level" styleClass="w-full" appendTo="body" [showClear]="true"
          (onChange)="onCourseLevelChange()" [style]="{'border-color': '#e2e8f0', 'border-radius': '8px'}" />
      </div>

      <div>
        <label class="font-bold text-sm mb-2 block" style="color: #0f172a;">Course</label>
        <p-dropdown [options]="filteredCourses" [(ngModel)]="selectedCourse" optionLabel="courseName" [filter]="true"
          filterBy="courseName" placeholder="Select Course" styleClass="w-full" appendTo="body" [showClear]="true"
          (onChange)="onCourseSelectionChange()" [style]="{'border-color': '#e2e8f0', 'border-radius': '8px'}">
          <ng-template pTemplate="selectedItem" let-course>
            <div class="flex flex-column">
              <span>{{course.courseName}}</span>
            </div>
          </ng-template>
          <ng-template let-course pTemplate="item">
            <div class="flex flex-column">
              <span>{{course.courseName}}</span>
              <small class="text-gray-500">{{course.courseLevel}}</small>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div>
        <label class="font-bold text-sm mb-2 block" style="color: #0f172a;">Intake Year</label>
        <p-dropdown [options]="intakeYears" [(ngModel)]="selectedIntakeYear" placeholder="Select Intake Year"
          styleClass="w-full" appendTo="body" [showClear]="true" [style]="{'border-color': '#e2e8f0', 'border-radius': '8px'}" />
      </div>

      <div *ngIf="portal === 'mentor'">
        <label class="font-bold text-sm mb-2 block" style="color: #0f172a;">Select Deadline Date</label>
        <div class="flex align-items-stretch w-full">
          <div class="flex-1 relative">
            <p-calendar [(ngModel)]="selectedDeadline" [minDate]="minDate" [maxDate]="maxDate" [readonlyInput]="true"
              placeholder="Pick a date..." dateFormat="mm/dd/yy" appendTo="body" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%', 'height': '44px', 'border-top-right-radius': '0', 'border-bottom-right-radius': '0', 'padding-left': '1rem', 'border-color': '#e2e8f0'}"
              styleClass="custom-calendar-input">
            </p-calendar>
          </div>
          <div
            class="flex align-items-center justify-content-center px-3 border-round-right-lg cursor-pointer"
            style="background-color: #000086; border-top-right-radius: 8px; border-bottom-right-radius: 8px;">
            <i class="pi pi-calendar text-white text-lg"></i>
          </div>
        </div>
        <small class="text-gray-400 mt-1 block" *ngIf="maxDate">
          Must be on or before official deadline ({{ maxDate | date: 'dd MMM yyyy' }})
        </small>
      </div>

      <small *ngIf="courses.length === 0" class="text-red-500 block mt-2">
        No courses available for this institute.
      </small>

      <div class="mt-4 mb-2 px-2">
        <button pButton class="w-full flex justify-content-center align-items-center"
          style="background-color: #000086; color: white; border: none; height: 56px; border-radius: 14px; font-weight: 600; font-size: 18px; cursor: pointer; transition: background-color 0.2s;"
           [disabled]="!selectedCourse || !selectedIntakeYear" 
           (click)="confirmSave()">
          {{ actionType === 'save' ? 'Add to My colleges' : 'Direct Apply to Course' }}
        </button>
      </div>

    </div>
  </div>

</p-dialog>